// extracted by mini-css-extract-plugin
export default {"modal":"BalanceModal_modal__yCFmk","bcg":"BalanceModal_bcg__9FRqT","polygon":"BalanceModal_polygon__B0Aq0","textA":"BalanceModal_textA__mfTRT","textB":"BalanceModal_textB__aYQxe"};